import { render, staticRenderFns } from "./managers.vue?vue&type=template&id=4b66bcf0&scoped=true&"
import script from "./managers.vue?vue&type=script&lang=js&"
export * from "./managers.vue?vue&type=script&lang=js&"
import style0 from "./managers.vue?vue&type=style&index=0&id=4b66bcf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66bcf0",
  null
  
)

export default component.exports